import React, { useState } from 'react';
import RangePicker from '../../../shared/Point/Filters/RangePicker/RangePicker';
import Select from 'react-select';

export default function Filter() {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const handleChangeStartDate = date => {
        setStartDate(date);
    };

    const handleChangeEndDate = date => {
        setEndDate(date);
    };
    return (
        <div className={'filters'}>
            <Select
                className='common-select common-select--filters'
                classNamePrefix='common'
                menuPlacement={'auto'}
                isSearchable={false}
                getOptionLabel={option => option.value}
                getOptionValue={option => option.id}
                options={[
                    { id: 0, value: 'Descending Date' },
                    { id: 1, value: 'Lorem Ipsum' },
                    { id: 2, value: 'Half Time' },
                    { id: 3, value: 'Under/Over' },
                    { id: 4, value: 'Goals' },
                    { id: 5, value: 'Handicap' },
                ]}
            />
            <Select
                className='common-select common-select--filters'
                classNamePrefix='common'
                menuPlacement={'auto'}
                isSearchable={false}
                getOptionLabel={option => option.value}
                getOptionValue={option => option.id}
                options={[
                    { id: 0, value: 'Period' },
                    { id: 1, value: 'Full Time' },
                    { id: 2, value: 'Half Time' },
                    { id: 3, value: 'Under/Over' },
                    { id: 4, value: 'Goals' },
                    { id: 5, value: 'Handicap' },
                ]}
            />
            <RangePicker />

            <div className='m-l-auto'>
                <button className='filter-button'>Request Thermal Roll</button>
            </div>
        </div>
    );
}
